export const seriesId = [
  "dce",
  "ci",
  "dmse",
  "dde"
]

export const seriesEsp = [
  "Dinámica del crecimiento económico",
  "Calidad institucional",
  "Dinámica monetaria y de sector exterior",
  "Dinámica del endeudamiento"
]

export const seriesEng = [
  "Dynamics of economic growth",
  "Institutional quality",
  "Monetary and foreign sector dynamics",
  "Debt dynamics"
]

export const countriesDataEsp = [
  "Australia",
  "Austria",
  "Bélgica",
  "Canadá",
  "República Checa",
  "Dinamarca",
  "Finlandia",
  "Francia",
  "Alemania",
  "Grecia",
  "Hong Kong SAR",
  "Irlanda",
  "Israel",
  "Italia",
  "Japón",
  "Corea del Sur",
  "Países Bajos",
  "Noruega",
  "Portugal",
  "Singapur",
  "España",
  "Suecia",
  "Suiza",
  "Taiwán",
  "Reino Unido",
  "Estados Unidos de América",
  "Argelia",
  "Argentina",
  "Bangladesh",
  "Brasil",
  "Chile",
  "China",
  "Colombia",
  "Egipto",
  "Hungría",
  "India",
  "Indonesia",
  "Irán",
  "Kazajstán",
  "Kuwait",
  "Malasia",
  "México",
  "Marruecos",
  "Nigeria",
  "Pakistán",
  "Perú",
  "Filipinas",
  "Polonia",
  "Katar",
  "Rumania",
  "Rusia",
  "Arabia Saudita",
  "Sudáfrica",
  "Sri Lanka",
  "Thailandia",
  "Turquía",
  "Ucrania",
  "Emiratos Árabes Unidos",
  "Venezuela",
  "Vietnam"
]

export const countriesDataEng = [
  "Australia",
  "Austria",
  "Belgium",
  "Canada",
  "Czechia",
  "Denmark",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hong Kong",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "South Korea",
  "Netherlands",
  "Norway",
  "Portugal",
  "Singapore",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "United Kingdom",
  "United States of America",
  "Algeria",
  "Argentina",
  "Bangladesh",
  "Brazil",
  "Chile",
  "China",
  "Colombia",
  "Egypt",
  "Hungary",
  "India",
  "Indonesia",
  "Iran",
  "Kazakhstan",
  "Kuwait",
  "Malaysia",
  "Mexico",
  "Morocco",
  "Niger",
  "Pakistan",
  "Peru",
  "Philippines",
  "Poland",
  "Qatar",
  "Romania",
  "Russia",
  "Saudi Arabia",
  "South Africa",
  "Sri Lanka",
  "Thailand",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "Venezuela",
  "Vietnam"
]
